import * as React from "react";

import useOneClickStore, { OneClickStore } from "../../Hooks/useOneClickStore";
import "../../Styles/component/authoring/handshake/one-click-handshake.sass";
import SingleCorrectionPad from '../SingleCorrectionPad/SingleCorrectionPad';

type OneClickHandshakeProps = {
    isPreview?: boolean;
}

export const OneClickHandshake: React.FC<OneClickHandshakeProps> = ({ isPreview }) => {
    const textLength = useOneClickStore((store: OneClickStore) => store.bufferText.length);
    const isSingleCorrectionMode = useOneClickStore((store: OneClickStore) => store.singleCorrectionActiveIndex >= 0);

    if (isSingleCorrectionMode) {
        return <SingleCorrectionPad />
    }

    if (!isPreview && textLength !== 0) {
        return (
            <div>
                <div className="handshake__title_with_text">Klicken Sie auf einen Satz.</div>
                <div className="handshake__description_with_text">
                    Dadurch werden alle Satzänderungen  <br />
                    kenntlich gemacht.
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="handshake__title_without_text">Korrektur auf <br /> Knopfdruck</div>
            <div className="handshake__description_without_text">
                Lassen Sie Ihre Texte mit nur einem Klick optimieren.
            </div>
        </div>
    );
};
